module.exports = __webpack_public_path__ + "static/inaki-del-olmo-NIJuEQw0RKg-unsplash-b155ddc61a50e633c4981106e6b3edef.jpg";